module.exports = __webpack_public_path__ + "img/exam-sport.1b535ab4.png";